import {
  AUTH_GET_PERMISSIONS,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_ERROR,
  AUTH_CHECK
} from "react-admin";
import base64 from "base-64";
require("dotenv")
const environment = process.env.NODE_ENV || "development";
const primaryCompany = process.env.REACT_APP_PRIMARY_ORG;

// console.log(environment);
export const PUBLIC_API_URL =
  environment === "development"
    ? `https://www.${primaryCompany}-proxyapp.ca/public`
    : `https://www.${primaryCompany}-proxyapp.ca/public`;
// console.log('authp',PUBLIC_API_URL);
// console.log(process.env);
// Authenticatd by default
export default (type, params) => {
  console.log(type, params);
  if (type === AUTH_LOGIN) {
    const { username, password } = params;
    const request = new Request(`${PUBLIC_API_URL}/user/login`, {
      method: "POST",
      body: JSON.stringify({ username, password }),
      headers: new Headers({ "Content-Type": "application/json" })
    });
    return fetch(request)
      .then(async response => {
        if (response.status < 200 || response.status >= 300) {
          localStorage.setItem("not_login", true);
          let { msg } = await response.json();
          throw new Error(msg);
        }
        return response.json();
      })
      .then(json => {
        localStorage.setItem("accessToken", json.accessToken);
        localStorage.setItem("userId", json.userId);
        localStorage.setItem("refreshToken", json.refreshToken);
        if (json.permissions.length > 0)
          localStorage.setItem("permissions", json.permissions);
        else localStorage.setItem("permissions", "null");
      });
  }
  if (type === AUTH_LOGOUT) {
    localStorage.removeItem("permissions");
    localStorage.removeItem("userId");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    return Promise.resolve();
  }
  if (type === AUTH_ERROR) {
    const { status } = params;
    if (status === 401 || status === 403) {
      localStorage.removeItem("permissions");
      localStorage.removeItem("userId");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      return Promise.reject();
    }
    // else if (status === 400) {
    //   console.log('------', params.body.msg);
    //   // throw new Error(params.body.msg);
    //   // throw new Error(params.body.msg);
    //   return Promise.reject(params.body.msg);
    // }
    else return Promise.resolve();
  }
  if (type === AUTH_CHECK) {
    const refreshToken = localStorage.getItem("refreshToken");
    if (refreshToken) {
      const encodedPayload = refreshToken.split(".")[1];
      const decodedPayload = JSON.parse(base64.decode(encodedPayload));
      const expirationTime = decodedPayload.exp;
      if (Date.now() >= expirationTime * 1000) return Promise.reject();
      return Promise.resolve();
    }
    return Promise.reject("Unknown method");

  }
  if (type === AUTH_GET_PERMISSIONS) {
    const role = localStorage.getItem("permissions");
    return !role ? Promise.reject() : Promise.resolve(role);
  }
  return Promise.reject("Unknown method");
};
